(() => {
  'use strict';

  if (window.__SNS_CUSTOMER_CART_MEDIA__) return;
  window.__SNS_CUSTOMER_CART_MEDIA__ = true;

  const revealCartMedia = () => document.documentElement.classList.remove('sns-cart-media-pending');
  const revealSafety = window.setTimeout(revealCartMedia, 1800);

  const IMAGE_PROP = '_sns_customer_media_image';
  let timer = null;
  let applying = false;

  const rootRoute = () => (window.Shopify?.routes?.root) || '/';

  async function getCart() {
    try {
      const res = await fetch(`${rootRoute()}cart.js`, {
        credentials: 'same-origin',
        headers: {'Accept':'application/json'}
      });
      if (!res.ok) return null;
      return await res.json();
    } catch (_) {
      return null;
    }
  }

  function setImage(img, url) {
    if (!img || !url) return;
    if (img.dataset.snsCustomerImage === url) return;

    img.dataset.snsCustomerImage = url;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;

    const picture = img.closest('picture');
    picture?.querySelectorAll('source').forEach(source => {
      source.removeAttribute('srcset');
      source.removeAttribute('sizes');
    });
  }

  function patchRows(container, items) {
    if (!container || !items?.length) return;

    const rows = Array.from(container.querySelectorAll('.cart-item'));
    rows.forEach((row, index) => {
      const item = items[index];
      const url = item?.properties?.[IMAGE_PROP];
      if (!url) return;

      const img =
        row.querySelector('.cart-item__media img') ||
        row.querySelector('img.cart-item__image') ||
        row.querySelector('.cart-item__image-container img');

      setImage(img, url);
    });
  }

  function patchNotification() {
    try {
      const last = JSON.parse(sessionStorage.getItem('snsCustomerMediaLastAdded') || 'null');
      if (!last?.image) return;

      const notification =
        document.querySelector('#cart-notification-product') ||
        document.querySelector('.cart-notification-product');

      if (!notification) return;
      const img = notification.querySelector('img');
      setImage(img, last.image);
    } catch (_) {}
  }

  async function apply() {
    if (applying) return;
    applying = true;

    try {
      const cart = await getCart();
      if (cart?.items) {
        document.querySelectorAll('cart-items, #main-cart-items, .cart__items').forEach(container => patchRows(container, cart.items));
        document.querySelectorAll('cart-drawer-items, #CartDrawer, .drawer__inner').forEach(container => patchRows(container, cart.items));
      }

      patchNotification();
    } finally {
      applying = false;
      clearTimeout(revealSafety);
      revealCartMedia();
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, {once:true});
  } else {
    schedule();
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {childList:true, subtree:true});

  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:update', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();